// import { FaStar } from 'react-icons/fa';
// import './review.scss';
// import { useState } from 'react';

// export default function Reviews({ review }) {


//     return (
//         <div className="review-card">
//             <div className='review-header'>
//                 <div className='stars'>
//                     {review.stars} <FaStar style={{
//                         color: "#f6b100"
//                     }} />
//                 </div>
//                 <p>{review.date}</p>
//             </div>
//             <div className="review-contentt">
//                 {review.message}

//             </div>
//             <div className="review-footer">
//                 {review.name}  
//             </div>
//         </div>
//     );
// }

import { FaStar } from "react-icons/fa";
import "./review.scss";
export default function Reviews({ review }) {
  return (<div className="testimonial-card">
    <div className="testimonial-top">
      <div className="stars">
        {[1, 2, 3, 4, 5].map((i) =>
          (<FaStar key={i} className={i <= review.stars ? "star active" : "star"} />))}
      </div> <span className="review-date">{review.date}</span> </div>
    <p className="testimonial-message"> {review.message} </p>
    <div className="testimonial-footer">
      <div className="avatar"> {review.name.charAt(0)} </div>
      <div className="author-info"> <h4>{review.name}</h4>
        <span>Verified Traveler</span>
      </div> </div> </div>);
}
